export const paymentRouteDef = [ 
    // {
    //     path:'payment_admid',
    //     component: 'PaymentDetailComponent',
    //     data: {
    //         selector: 'app-payment-detail'
    //     }
    // },
    // {
    //     path:'payment_uhid',
    //     component: 'PaymentDetailComponent',
    //     data: {
    //         selector: 'app-payment-detail'
    //     }
    // },
    // {
    //     path:'op_settlement',
    //     component: 'PaymentDetailComponent',
    //     data: {
    //         selector: 'app-payment-detail'
    //     }
    // },
    {
        path: 'dispatchedBill_settlement/:id',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'dispatchedBill_settlement',
            action: 'ADD',

        }
    },
    
    {
        path: 'payment_detail',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            resource: 'package_multiple_payment',
            action: 'LIST',
        }
    },
    {
        path: 'draftBill_settlement/:id',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'draftBill_settlement',
            action: 'ADD',

        }
    },
    {
        path: 'partialBill_settlement/:id',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'partialBill_settlement',
            action: 'ADD',

        }
    },
    {
        path: 'settleDue',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'due_settlement',
            action: 'ADD',
        }
    },
    {
        path: 'settleDueip',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'due_settlementip',
            action: 'ADD',
        }
    },
    // {
    //     path: 'bulkSettlement',
    //     component:'BulkSettlementComponent',
    //     data : {
    //         selector: 'app-bulk-settlement'
    //     }
    // },
    {
        path: 'opbilling',
        component:'OpBillingComponent',
        data : {
            selector: 'app-op-billing'
        }
    },
    {
        path: 'opbillingorder',
        component:'OpBillingComponent',
        data : {
            selector: 'app-op-billing',
            action:'createorderb'
        }
    },
    {
        path: 'approvebilling',
        component:'ApproveBillingComponent',
        data : {
            selector: 'kx-approve-billing',
            action:'approvedBilling'
        }
    },
    {
        path: 'opbillingbill',
        component:'OpBillingComponent',
        data : {
            selector: 'app-op-billing',
            action:'createb'
        }
    },
    {
        path: 'opbillingeditbill',
        component:'OpBillingEditBillComponent',
        data : {
            selector: 'app-op-billing-edit-bill',
            action:'createEdit'
        }
    },
    {
        path: 'op_counselling_billing',
        component:'OpBillingComponent',
        data : {
            selector: 'app-op-billing'
        }
    },
    {
        path: 'opbilling/viewdetail',
        component:'OpBillingComponent',
        data : {
            selector: 'app-op-billing'
        }
    },
    {
        path: 'opbillingeditbill',
        component:'OpBillingEditBillComponent',
        data : {
            selector: 'app-op-billing-edit-bill'
        }
    },
    {
        path: 'opbillingeditbill/vieweditdetail',
        component:'OpBillingEditBillViewComponent',
        data : {
            selector: 'app-op-billing-edit-bill-view'
        }
    },
    {
        path: ':resource/payment',
        component:'ReportDataTableComponent',
        data : {
            selector: 'app-report-data-table',
            action: 'LIST'
        }
    },
    {
        path: 'oprefund',
        component:'OpRefundComponent',
        data : {
            selector: 'app-op-refund',
            action:'processRefund'
        }
    },
    {
        path: 'oprefund/viewRefund',
        component:'OpRefundComponent',
        data : {
            selector: 'app-op-refund',
            action:'viewRefund'
        }
    },
        {
        path: 'oprefund/viewFormSixty',
        component:'OpRefundComponent',
        data : {
            selector: 'app-op-refund',
            action:'viewFormSixty'
        }
    },
    {
        path: 'user_collection_summary',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            type:'summary'
        }
    },
    {
        path: 'user_collection_detail',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            type:'detail'
        }
    },
    {
        path: 'view_breakup_details',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            resource: "collection_detail_format_old",
            type:'detailed_breakup'
        }
    },
        {
        path: ':id/:resource/viewss',
      component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'user_collection_summary',
                        id: 'id',
            action: 'VIEW',
            view: 'cash_denomination'
        }
    },

    {
        path: 'view_breakup_detailsv1',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            resource: "user_collection_summary",
            type:'detailed_breakup'
        }
    },
    {
        path: 'view_breakup_details_custom',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            resource: "custom_collection_format",
            type:'detailed_breakup'
        }
    },
    {
        path: 'advance_approve/:id',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'advance_approve',
            action: 'LIST',

        }
    },
    {
        path: 'view_breakup_summary',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            resource: "collection_detail_format_old",
            type:'summary_breakup'
        }
    },
    {
        path: 'view_breakup_summaryv1',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            resource: "collection_detail_format",
            type:'summary_breakup'
        }
    },
    {
        path: 'cashier_collection',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            type:'cashier'
        }
    },
    {
        path: 'cashier_collection_detail',
        component:'UserCollectionCommon',
        data : {
            selector: 'app-user-collection-common',
            type:'collection_detail'
        }
    },
    {
        path:':resource/walkIn',
        component:'ItemConsumptionComponent',
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_walkin'
        }
    },
    {
        path:':orderId/:resource/OpItemDraftProcess',
        component:'ItemConsumptionComponent',
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_draft'
        }
    },
    {
        path:':orderId/:resource/OpItemDraftConsignmentProcess',
        component:'ItemConsumptionComponent',
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_walkin_consignment_draft'
        }
    },
    {
        path:':orderId/:resource/itemRequest',
        component:'ItemConsumptionComponent', 
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_request'
        }
    },
    {
        path:':orderId/:resource/itemCompleted',
        component:'ItemConsumptionComponent',
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_completed'
        }
    },
    {
        path:':orderId/:resource/itemDetails',
        component:'ItemConsumptionComponent', 
        data : {
            selector: 'kx-item-consumption',
            resource: 'item_consumption_draft'
        }
    },
    {
        path: 'autoConsultation/add',
        component: 'ViewCountGridComponent',
        data: {
            selector: 'app-view-count-grid',
            resource:'auto_consultation',
            input:'auto_consultation',
            action:'ADD'
        }
    }, 
        {
        path: 'due_bulk_settlement',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource:'due_bulk_settlement',
            action:'ADD'
        }
    }, 
    {
        path: 'uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'document_billing_op',
            action: 'IMAGE_VIEWER',
        }
    }
]       